import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MIHttpClientService} from '../mi-http-client.service';
import {IMetricsWidget, IVisitCounterWidget} from './widgets';
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root',
})
export class WidgetService {

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  retrieveMyMetricsData(): Observable<any> {
    return this.miClient.get<IMetricsWidget[]>('reports/metricsWidget');
  }

  retrieveDownLineMetricsData(userId: number): Observable<any> {
    return this.miClient.get<IMetricsWidget[]>('reports/metricsWidget/' + userId);
  }

  retrieveMyVisitCounterData(): Observable<any> {
    return this.miClient.get<IVisitCounterWidget[]>('reports/visitCounterV2/').pipe(
      map(metrics => metrics.filter(item => item.visitDetails !== '0/0')),
    );
  }

  retrieveDownLineVisitCounterData(userId: number): Observable<any> {
    return this.miClient.get<IVisitCounterWidget[]>('reports/visitCounterV2/' + userId).pipe(
      map(metrics => metrics.filter(item => item.visitDetails !== '0/0')),
    );
  }

}
